import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-editicon",
  templateUrl: "./editicon.component.html",
  styleUrls: ["./editicon.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class EditiconComponent implements OnInit {
  @Input() type: string;
  @Input() description: string;
  @Input() class: string;
  @Input() data: string;
  @Input() disabled: boolean;
  @Output() callFunction = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onClick(event) {
    this.callFunction.emit(event);
  }
}
